import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { Routes, Route } from 'react-router-dom';

import { Container, BlockUi } from '@availity/element';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Message from '../components/Message';

import Request from '../../Request';
import PublicFacingLandingPage from '../../Request/components/PublicFacingLandingPage';
import QuestionnaireWizard from '../../QuestionnaireWizard';

import CommonStore from '../stores/CommonStore';
import MessageStore from '../stores/MessageStore';

const Layout = ({ commonStore, messageStore }) => {
  const { inPublicfacingFlow } = commonStore;

  const renderRootPath = () => (
    <Routes>
      <Route path="/" element={!inPublicfacingFlow ? <Request /> : <PublicFacingLandingPage />} />
      <Route path="/wizard" element={<QuestionnaireWizard />} />
      <Route path="/wizard/:step" element={<QuestionnaireWizard />} />
      <Route path="*" element={!inPublicfacingFlow ? <Request /> : <PublicFacingLandingPage />} />
    </Routes>
  );

  const FooterComponent = !inPublicfacingFlow ? <Footer commonStore={commonStore} /> : null;

  return (
    <BlockUi blocking={commonStore.blocking} message={<span style={{ fontWeight: 'bold' }}>Loading...</span>}>
      <Container>
        <Header commonStore={commonStore} />
        <Message messageStore={messageStore} />
        {renderRootPath()}
        {FooterComponent}
      </Container>
    </BlockUi>
  );
};

export default inject('commonStore', 'messageStore')(observer(Layout));

Layout.propTypes = {
  commonStore: PropTypes.instanceOf(CommonStore).isRequired,
  messageStore: PropTypes.instanceOf(MessageStore).isRequired,
};
